export function ItemCondensedSkeleton() {
  return (
    <div className="twc-flex twc-gap-4 animate-pulse">
      <div className="twc-basis-12 twc-aspect-4/5 twc-bg-gray-200 twc-rounded" />
      <div className="twc-h-6 twc-basis-52 twc-bg-gray-200 twc-rounded" />
      <div className="twc-h-6 twc-basis-12 twc-bg-gray-200 twc-rounded twc-ml-auto" />
    </div>
  )
}
